import { TOKEN_STORAGE_KEY } from "store/api/axiosApi";
import {
  updateTokenExpiredStatus,
  updateTokenStatus,
} from "store/slices/authSlice";
import { clearSlice } from "utils/HelperFunctions";

// A payment link, invoice, agreement or quote opened by a customer logged in
// as a different account signs them out and reloads the page. The reload
// clears localStorage, so the flag that says why lives in sessionStorage and
// the page shows the message once after it comes back.
const NOTICE_KEY = "dcdial-link-account-mismatch";

export type LinkKind = "payment link" | "invoice" | "agreement" | "quote";

export const linkAccountMismatchMessage = (kind: LinkKind) =>
  `This ${kind} belongs to a different account. Log in with the account it was sent to.`;

export const signOutOtherAccount = (
  dispatch: any,
  reload: () => void = () => window.location.reload()
) => {
  clearSlice(dispatch);
  localStorage.removeItem(TOKEN_STORAGE_KEY);
  dispatch(updateTokenExpiredStatus(false));
  dispatch(updateTokenStatus(false));
  localStorage.clear();
  try {
    sessionStorage.setItem(NOTICE_KEY, "1");
  } catch {
    // Without sessionStorage the page still signs out, just without the notice.
  }
  reload();
};

// True once after signOutOtherAccount; reading it clears it.
export const takeLinkAccountMismatch = (): boolean => {
  try {
    const flagged = sessionStorage.getItem(NOTICE_KEY) === "1";
    sessionStorage.removeItem(NOTICE_KEY);
    return flagged;
  } catch {
    return false;
  }
};
